/* Progressive galleries over the existing merchant body; no globals or autoplay. */
(() => {
  if (customElements.get('mm-bulk-support')) return;
  customElements.define('mm-bulk-support', class extends HTMLElement {
    connectedCallback() {
      if (!this.prepared) {
        this.prepareGalleries();
        this.preparePackaging();
        this.prepared = true;
      }
      this.onClick = event => {
        const arrow = event.target.closest('button[data-bulk-gallery-direction]');
        if (arrow && this.contains(arrow)) {
          this.moveGallery(arrow.closest('.gallery-wrapper').querySelector('.gallery-container'), Number(arrow.dataset.bulkGalleryDirection));
          return;
        }
        const thumbnail = event.target.closest('[data-bulk-thumbnail]');
        if (thumbnail && this.contains(thumbnail)) this.selectPackage(thumbnail.closest('.thumbnail-card'));
      };
      this.onKey = event => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        if (!event.target.matches('.gallery-container.is-scrollable')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          const rtl = getComputedStyle(event.target).direction === 'rtl';
          this.moveGallery(event.target, (event.key === 'ArrowLeft' ? -1 : 1) * (rtl ? -1 : 1));
        }
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
    }
    prepareGalleries() {
      this.querySelectorAll('.gallery-wrapper').forEach((wrapper, index) => {
        const gallery = wrapper.querySelector('.gallery-container');
        if (!gallery) return;
        let heading = wrapper.previousElementSibling;
        while (heading && !heading.matches('h2,h3')) heading = heading.previousElementSibling;
        if (heading && !heading.id) heading.id = `${this.id}-gallery-heading-${index + 1}`;
        gallery.id ||= `${this.id}-gallery-${index + 1}`;
        gallery.tabIndex = 0;
        gallery.setAttribute('role', 'region');
        if (heading) gallery.setAttribute('aria-labelledby', heading.id);
        else gallery.setAttribute('aria-label', 'Customization examples');
        gallery.classList.add('is-scrollable');
        wrapper.querySelectorAll('.gallery-arrow').forEach(legacy => {
          const direction = legacy.classList.contains('left') ? -1 : 1;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = legacy.className;
          button.dataset.bulkGalleryDirection = String(direction);
          button.setAttribute('aria-controls', gallery.id);
          button.setAttribute('aria-label', `${direction < 0 ? 'Previous' : 'Next'} images: ${heading?.textContent.trim() || 'customization examples'}`);
          const rtl = getComputedStyle(gallery).direction === 'rtl';
          button.textContent = direction * (rtl ? -1 : 1) < 0 ? '←' : '→';
          legacy.remove();
          wrapper.append(button);
        });
      });
    }
    moveGallery(gallery, direction) {
      const rtl = getComputedStyle(gallery).direction === 'rtl';
      const amount = Math.max(1, gallery.clientWidth * 0.8) * direction * (rtl ? -1 : 1);
      const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      if (gallery.scrollBy) gallery.scrollBy({ left: amount, behavior: reduced ? 'auto' : 'smooth' });
      else gallery.scrollLeft += amount;
    }
    preparePackaging() {
      const gallery = this.querySelector('.packaging-gallery');
      const main = gallery?.querySelector('#mainImage');
      if (!main) return;
      const info = gallery.querySelector('.image-info');
      info?.setAttribute('aria-live', 'polite');
      info?.setAttribute('aria-atomic', 'true');
      gallery.querySelectorAll('.thumbnail-card').forEach((card, index) => {
        const image = card.querySelector('img');
        const label = card.querySelector('.thumbnail-label');
        if (!image || !label || !card.getAttribute('src')) return;
        label.id ||= `${this.id}-package-${index + 1}`;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'mm-bulk-thumbnail-button';
        button.dataset.bulkThumbnail = '';
        button.setAttribute('aria-labelledby', label.id);
        button.setAttribute('aria-controls', 'mainImage imgTitle imgDescription');
        button.setAttribute('aria-pressed', String(card.getAttribute('src') === main.getAttribute('src')));
        card.classList.toggle('active', button.getAttribute('aria-pressed') === 'true');
        card.insertBefore(button, image);
        button.append(image);
        if (card.dataset.desc) {
          const description = document.createElement('p');
          description.className = 'mm-bulk-thumbnail-description';
          description.textContent = card.dataset.desc;
          card.append(description);
        }
      });
    }
    selectPackage(card) {
      const gallery = card.closest('.packaging-gallery');
      const main = gallery.querySelector('#mainImage');
      if (!main) return;
      main.src = card.getAttribute('src');
      main.alt = card.querySelector('img')?.alt || card.dataset.title || '';
      const title = gallery.querySelector('#imgTitle');
      const description = gallery.querySelector('#imgDescription');
      if (title) title.textContent = card.dataset.title || '';
      if (description) description.textContent = card.dataset.desc || '';
      gallery.querySelectorAll('.thumbnail-card').forEach(candidate => {
        const selected = candidate === card;
        candidate.classList.toggle('active', selected);
        candidate.querySelector('[data-bulk-thumbnail]')?.setAttribute('aria-pressed', String(selected));
      });
    }
  });
})();
